import React from "react";
import { SiGmail } from "react-icons/si";
import {
  FaGithub,
  FaFacebook,
  FaWhatsappSquare,
  FaLinkedin,
  FaMedium,
} from "react-icons/fa";
import { Wrapper, Icon } from "./Contact.styled";

const contacts = [
  {
    link: "https://www.linkedin.com/in/mark-john-allen-nizal-112945301",
    icon: FaLinkedin,
  },
  {
    link: "https://medium.com/@marknizal",
    icon: FaMedium,
  },
  {
    link: "https://github.com/marknizal",
    icon: FaGithub,
  },
  {
    link: "https://www.facebook.com/mjacn07/",
    icon: FaFacebook,
  },
  {
    link: "https://wa.me/09815152341",
    icon: FaWhatsappSquare,
  },
  {
    link: "mailto:marknizal@gmail.com",
    icon: SiGmail,
  },
];

const ContactList = () => {
  return (
    <Wrapper>
      {contacts.map((contact, index) => (
        <a
          key={index}
          href={contact.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <li>
            <Icon>
              <contact.icon />
            </Icon>
          </li>
        </a>
      ))}
    </Wrapper>
  );
};

export default ContactList;
